var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsIP, IsSemVer, IsString, IsUUID } from 'class-validator';
import 'reflect-metadata';
import { UserProfileDto } from '../../user/index.js';
export class AppFeedbackFullSizeDto {
    id;
    createdAt;
    updatedAt;
    frontendVersion;
    ipAddress;
    userId;
    user;
    content;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], AppFeedbackFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], AppFeedbackFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], AppFeedbackFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsSemVer(),
    Expose(),
    __metadata("design:type", String)
], AppFeedbackFullSizeDto.prototype, "frontendVersion", void 0);
__decorate([
    IsIP(),
    Exclude(),
    __metadata("design:type", String)
], AppFeedbackFullSizeDto.prototype, "ipAddress", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", Object)
], AppFeedbackFullSizeDto.prototype, "userId", void 0);
__decorate([
    Type(() => UserProfileDto),
    Expose(),
    __metadata("design:type", Function)
], AppFeedbackFullSizeDto.prototype, "user", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], AppFeedbackFullSizeDto.prototype, "content", void 0);
//# sourceMappingURL=app-feedback.full-size.dto.js.map